import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getAgreement} from '@/api/miscellaneous';
import {useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Agreement',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const detail = ref<any>({});

const getContent = () => {
    const id = route.query.id as string;
    getAgreement({id}).then(res => {
        detail.value = res;
    });
};
getContent();

const __returned__ = { route, detail, getContent, ref, getAgreement, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})